<template>
    <button
        type="button"
        class="ai-analysis-preset-card text-start rounded-lg p-2.5 border transition-colors"
        :class="selected ? 'is-selected border-active-elements bg-primary-100' : 'bg-main-bg'"
        @click="$emit('select')"
    >
        <div class="text-sm font-semibold truncate mb-0.5">
            {{ preset.Name }}
        </div>

        <p
            class="text-main-xs text-gray-500 mb-2 line-clamp-2"
            :title="preset.Description"
        >
            {{ preset.Description }}
        </p>

        <div class="flex flex-wrap items-center gap-1">
            <RedesignTag
                v-for="name in categoryNames"
                :key="name"
                :tag-content="[ { text: name } ]"
                :color="tagTextColor"
                :background-color="tagBackgroundColor"
                padding-classes="px-1.5 py-0.5"
            />
        </div>
    </button>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import RedesignTag from '@/components/RedesignBaseComponents/RedesignTag.vue'
import { type CategorisedPromptTemplate } from '@/api/widgetParameterApi'

const props = defineProps<{
    preset: CategorisedPromptTemplate
    categoryNames: Array<string>
    selected?: boolean
}>()

defineEmits<{
    (e: 'select'): void
}>()

const tagTextColor = computed(() => props.selected ? 'var(--white)' : '')

const tagBackgroundColor = computed(() => {
    return props.selected
        ? 'color-mix(in srgb, var(--primary-actions) 70%, transparent)'
        : 'color-mix(in srgb, var(--secondary-actions) 20%, transparent)'
})
</script>

<style scoped lang="scss">
.ai-analysis-preset-card {
    border-color: var(--secondary-actions);

    &:hover:not(.is-selected) {
        border-color: var(--active-elements);
    }
}
</style>
